// import React from "react";
// import TableUtility from "../../../Common/UtilityCommon/TableUtility";

// const AwakRTGSUtility = () => {
//    const apiUrl = `${process.env.REACT_APP_API}/getall-RTGSData`;
//    const columns = [
//       { label: "Slip No", key: "Slip_No" },
//       { label: "Transiction Date", key: "Doc_Date" },
//       { label: "RTGS Party Name", key: "Ac_Name_E" },
//       { label: "Amount", key: "Amount" },
//       { label: "Total", key: "Total" },
//    ];
//    return (
//       <TableUtility
//          title="RTGS"
//          apiUrl={apiUrl}
//          columns={columns}
//          rowKey="Slip_No"
//          addUrl="/rtgs-form"
//          detailUrl="/rtgs-form"
//          permissionUrl="/RTGS-utility"
//          queryParams={{ Company_Code: sessionStorage.getItem("Company_Code") }}
//       />
//    );

// };


// export default AwakRTGSUtility;


import React, { useState } from "react";
import TableUtility from "../../../Common/UtilityCommon/TableUtility";
import { useNavigate } from "react-router-dom";

const AwakRTGSUtility = () => {
   const apiUrl = `${process.env.REACT_APP_API}/getall-RTGSData`;
   const columns = [
      { label: "Slip No", key: "Slip_No" },
      { label: "Transiction Date", key: "Doc_Date" },
      { label: "RTGS Party Name", key: "Ac_Name_E" },
      { label: "Amount", key: "Amount" },
      { label: "Total", key: "Total" },
   ];

   return (
      <TableUtility
         title="RTGS"
         apiUrl={apiUrl}
         columns={columns}
         rowKey="Slip_No"
         addUrl="/rtgs-form"
         detailUrl="/rtgs-form"
         permissionUrl="/RTGS-utility"
         queryParams={{ Company_Code: sessionStorage.getItem("Company_Code") }}
      />
   );
};

export default AwakRTGSUtility;
